// extracted by mini-css-extract-plugin
export var inline = "_va-0";